export const TASKS_CONTROL_PATH = "/tasks/control";
